import React from 'react';
import PropTypes from 'prop-types';

import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

import ManagedInput from 'components/form/managed_input';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class FilterNumberPair extends React.Component {
  static propTypes = {
    ...FormControl.propTypes,
    filter: PropTypes.object.isRequired,
    label: PropTypes.string,
    maxPlaceholder: PropTypes.string,
    minPlaceholder: PropTypes.string,
    name: PropTypes.string,
    newDesignSystem: PropTypes.bool,
    placeholder: PropTypes.string,
    valueKeys: PropTypes.array.isRequired,
    withIcon: PropTypes.any,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    name: '',
    newDesignSystem: false
  }

  minKey = () => this.props.valueKeys[0];
  maxKey = () => this.props.valueKeys[1];

  minValue = () => this.props.filter[this.minKey()];
  maxValue = () => this.props.filter[this.maxKey()];

  handleMaxChange = (_, event) => {
    this.props.onChange(event, this.maxKey());
  };

  handleMinChange = (_, event) => {
    this.props.onChange(event, this.minKey());
  };

  render() {
    const { label, newDesignSystem } = this.props;

    if (newDesignSystem) {
      return (
        <div>
          {label && <ControlLabel>{label}</ControlLabel>}
          <FormGroup className={`input-pair-container ${newDesignSystem ? 'm-0 d-flex align-items-center' : ''}`}>
            {this.renderMinValue()}
            <span className={`${newDesignSystem ? '' : 'top-buffer-xs'} pl-2 pr-2`}> - </span>
            {this.renderMaxValue()}
          </FormGroup>
        </div>
      );
    } else {
      return (
        <div className="filter-number-pair">
          {label && <ControlLabel>{label}</ControlLabel>}
          <FormGroup className={`input-pair-container ${newDesignSystem ? 'm-0 d-flex align-items-center' : ''}`}>
            {this.renderMinValue()}
            <span className={`${newDesignSystem ? '' : 'top-buffer-xs'} pl-2 pr-2`}> TO </span>
            {this.renderMaxValue()}
          </FormGroup>
        </div>
      );
    }
  }

  renderMinValue() {
    const { newDesignSystem, name, withIcon, minPlaceholder, placeholder } = this.props;

    if (newDesignSystem) {
      return (
        <span className="input-pair">
          {withIcon && <FontAwesomeIcon className="input-icon" icon={withIcon} />}
          <ManagedInput
            className={`input-selection form-control ${withIcon ? 'with-icon' : ''}`}
            name={`${name}_min`}
            placeholder={minPlaceholder || placeholder || 'Min'}
            type="number"
            value={this.minValue()}
            onChange={this.handleMinChange}
          />
        </span>
      );
    } else {
      return (
        <ManagedInput
          className="right-buffer-sm input-pair form-control"
          name={`${name}_min`}
          placeholder={placeholder || 'Min'}
          type="number"
          value={this.minValue()}
          onChange={this.handleMinChange}
        />
      );
    }
  }

  renderMaxValue() {
    const { newDesignSystem, name, withIcon, maxPlaceholder, placeholder } = this.props;

    if (newDesignSystem) {
      return (
        <span className="input-pair">
          {withIcon && <FontAwesomeIcon className="input-icon" icon={withIcon} />}
          <ManagedInput
            className={`input-selection form-control ${withIcon ? 'with-icon' : ''}`}
            name={`${name}_max`}
            placeholder={maxPlaceholder || placeholder || 'End'}
            type="number"
            value={this.maxValue()}
            onChange={this.handleMaxChange}
          />
        </span>
      );
    } else {
      return (
        <ManagedInput
          className="left-buffer-sm input-pair form-control"
          name={`${name}_max`}
          placeholder={placeholder || 'Max'}
          type="number"
          value={this.maxValue()}
          onChange={this.handleMaxChange}
        />
      );
    }
  }
}
